// 繁體中文表格（機器翻譯，未經人工審校 — ruling G4）。
// The Traditional Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const S = {
  title: "刻名字的手機殼",
  beta: "測試版",
  phone: "手機型號",
  forPhone: (name) => `${name} 的手機殼`,
  material: "材料",
  materials: {
    flex: "軟質（TPU）",
    rigid: "硬質（PETG）",
  },
  thick: "厚度",
  thicks: {
    slim: "超薄",
    standard: "標準",
    tough: "堅固",
  },
  fit: "鬆緊",
  fits: {
    tight: "緊密",
    normal: "剛好",
  },
  src: "背面圖案",
  textHint: (lines, chars) => `最多 ${lines} 行，每行至多 ${chars} 個字元`,
  loadingFont: (family, got, total) => (total > 0 ? `正在載入 ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `正在載入 ${family} ${got.toFixed(1)} MB`),
  finish: "圖案風格",
  finishes: {
    flush: "齊平，雙色",
  },
  turn: "方向",
  turns: {
    "0": "橫排",
    "90": "直排",
  },
  scale: "尺寸",
  pos: "位置",
  position: (v) => (Math.abs(v) < 0.005 ? '置中' : `${v > 0 ? '頂部' : '底部'} ${Math.round(Math.abs(v) * 100)}%`),
  needFile: "選擇 SVG 檔案——它只留在您的裝置上，不會傳送到任何地方",
  artKept: "圖案只存在於目前分頁——重新整理後需重新選擇檔案",
  keptOld: "（仍在使用先前的圖案）",
  thumb: "已讀取圖案的預覽",
  shareNoArt: "此連結不含 SVG 檔案——開啟的人需要自行選擇檔案",
  linkNeedsArt: "此設計使用了檔案裡的圖案，但連結不含該檔案——請選擇 SVG 檔案補上",
  gColour: "顏色",
  colourCase: "手機殼顏色",
  colourArt: "圖案顏色",
  notes: {
    untested: (name, material) => `尚未在 ${material} 上做 ${name} 的列印測試`,
    settings: "背面朝下列印，無需支撐，0.2 公厘層高",
    tested: (name, material) => `已在 ${material} 上通過 ${name} 的列印測試`,
    proud: (mm) => `鏡頭凸出背面 ${mm} 公厘——手機螢幕朝上放平時會晃`,
    flush: "齊平雙色圖案需要多色印表機和 3MF 檔案（STL 不含圖案，為閉合體）",
    engraved: "雕刻圖案為單色，無需換料——STL 或 3MF 都可以",
    pla: "不建議用 PLA——扣上時易裂、手機發熱時會變軟；請用 TPU 或 PETG",
    terms: "僅供學習與個人使用——風險自負",
  },
  size: (x, y, z) => `手機殼尺寸 ${x.toFixed(1)} × ${y.toFixed(1)} × ${z.toFixed(1)} 公厘`,
  grams: (g) => `約重 ${Math.round(g)} 公克`,
  views: {
    back: "背面",
    front: "正面",
    side: "側面",
  },
  problem: {
    "no-art": "沒有要列印的文字——得到素色手機殼",
    "thin-text": "字母很細——有些筆畫可能列印不出來；請用更大的尺寸或減少字元",
    "same-colour": "圖案顏色與殼身顏色相同——圖案將看不到",
    "thin-parts": "圖案的細筆畫連著厚實部分——切片軟體可能把它們切掉",
    dropped: (p) => `已從圖案中捨棄 ${p.n} 個過薄、無法列印的部分`,
    "all-thin": "圖案對這個尺寸來說太薄——無法下載",
    "art-too-complex": "圖案太複雜——無法下載",
    "wide-groove": (p) => `凹槽寬於 ${p.mm} 公厘時，封住它的那層要懸空列印——背面可能不平；請減小圖案尺寸或改用齊平雙色`,
  },
  dlstl: "STL",
  copied: "已複製",
  fatal: "無法載入計算器——請嘗試重新整理頁面",
  buildTimeout: "產生 10 秒未完成，已重新開始——請減少字元或換字型",
  aboutH2: "放名字手機殼的原理",
  aboutP1: "選 iPhone 16 Pro Max 或 iPhone 16 型號，放名字或標誌 SVG 檔案，下載 3MF 或 STL 去列印。手機殼背面朝下列印免支撐，邊緣微微包住螢幕邊框以扣住機身，並留出相機、Camera Control 按鍵和充電孔的開孔。",
  aboutP2: "平滑款用兩種顏色，圖案是與殼面齊平的第三種顏色 — 需要多色列印機；雕刻款單色即可。SVG 檔案只留在你的裝置上，不會被傳送到任何地方，也不會出現在複製的連結裡。",
  aboutPrint: "鬆緊數值（機身周圍的間隙、邊緣深度）來自其他設計師的做法；尚未實際列印並裝上真機驗證，只通過了 OrcaSlicer 的模擬和切片。",
  aboutTerms: "這個工具用於學習和個人使用，未經手機廠商認可；列印出來的殼可能不合身或不防摔，風險由使用者自行承擔。",
  aboutTrademark: "iPhone 是 Apple Inc. 的商標。這個工具不是 Apple 製作，也與 Apple 無關；型號名稱只用於說明殼適配哪款裝置。",
};
export default S;
